var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", { staticClass: "sidebar-cart__list-item" }, [
    _c("div", { staticClass: "sidebar-cart__list-item-image" }, [
      _vm.item.image.length
        ? _c("img", {
            staticClass: "sidebar-cart__list-item-image-element",
            attrs: { src: _vm.item.image[0].path, alt: "Product Image" },
          })
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "sidebar-cart__list-item-info" },
      [
        _c("div", {
          staticClass: "sidebar-cart__list-item-name",
          domProps: { innerHTML: _vm._s(_vm.item.name) },
        }),
        _vm._v(" "),
        _vm.item.unit
          ? _c("div", {
              staticClass: "sidebar-cart__list-item-meta",
              domProps: { innerHTML: _vm._s(_vm.item.unit) },
            })
          : _vm._e(),
        _vm._v(" "),
        _c("QuantityCounter", {
          attrs: {
            quantity: _vm.item.quantity,
            locked: _vm.locked,
            "base-class": "sidebar-cart__list-item-quantity",
          },
          on: {
            sub: function ($event) {
              return _vm.$emit("sub")
            },
            add: function ($event) {
              return _vm.$emit("add")
            },
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", {
      staticClass: "sidebar-cart__list-item-price",
      domProps: {
        innerHTML: _vm._s(
          _vm.$options.filters.madpricecent(_vm.item.originalTotal, "short")
        ),
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }